document.addEventListener('DOMContentLoaded', function() {
  const productHighlights = {
    // Elements
    products: document.querySelectorAll('.product-highlights__product'),
    shots: document.querySelectorAll('.product-highlights__shot'),
    nextButton: document.querySelector('.product-highlights__nav-button--next'),
    prevButton: document.querySelector('.product-highlights__nav-button--prev'),
    productTitle: document.querySelector('.navigation__product-title'),
    productPrice: document.querySelector('.navigation__product-price'),
    productContainer: document.querySelector('.product-highlights__products'),
    
    // State
    currentIndex: 0,
    isAnimating: false,
    totalItems: 0,
    autoSlideInterval: null,
    autoSlidePaused: false,
    
    // Initialize
    init: function() {
      this.totalItems = this.products.length;
      if (this.totalItems === 0) return;
      
      // Position all items initially at the right (default position)
      this.resetAllItems();
      
      // Set first items as active
      this.products[0].classList.add('active');
      this.shots[0].classList.add('active');
      
      // Set initial product info
      this.updateProductInfo(0, false);
      
      // Add event listeners
      this.nextButton.addEventListener('click', () => {
        if (!this.isAnimating) {
          this.goToNext();
          this.resetAutoSlide();
        }
      });
      this.prevButton.addEventListener('click', () => {
        if (!this.isAnimating) {
          this.goToPrev();
          this.resetAutoSlide();
        }
      });
      
      // Setup auto-slide
      this.startAutoSlide();
      
      // Add hover pause functionality
      if (this.productContainer) {
        this.productContainer.addEventListener('mouseenter', this.pauseAutoSlide.bind(this));
        this.productContainer.addEventListener('mouseleave', this.resumeAutoSlide.bind(this));
      }
    },
    
    // Reset all items to initial state (off-screen right)
    resetAllItems: function() {
      for (let i = 0; i < this.totalItems; i++) {
        // Reset classes - default position is off-screen to the right
        this.products[i].classList.remove('active', 'previous', 'next-out');
        this.shots[i].classList.remove('active', 'previous', 'next-out');
        
        // Set base z-index
        this.products[i].style.zIndex = 1;
        this.shots[i].style.zIndex = 1;
      }
    },
    
    // Go to next item
    goToNext: function() {
      if (this.isAnimating || this.totalItems <= 1) return;
      this.isAnimating = true;
      
      // Update button states
      this.updateButtonStates();
      
      // Get current and next indices
      const currentIndex = this.currentIndex;
      const nextIndex = (currentIndex + 1) % this.totalItems;
      const prevIndex = (currentIndex - 1 + this.totalItems) % this.totalItems;
      
      // First, set all items to base z-index
      for (let i = 0; i < this.totalItems; i++) {
        this.products[i].style.zIndex = 1;
        this.shots[i].style.zIndex = 1;
      }
      
      // Set specific z-indexes for involved items
      this.products[nextIndex].style.zIndex = 3; // Next item on top
      this.shots[nextIndex].style.zIndex = 3;
      this.products[currentIndex].style.zIndex = 2; // Current item middle
      this.shots[currentIndex].style.zIndex = 2;
      
      // Reset position of next item (ensure it starts from right)
      this.products[nextIndex].classList.remove('active', 'previous', 'next-out');
      this.shots[nextIndex].classList.remove('active', 'previous', 'next-out');
      
      // Make current item slide out to left
      this.products[currentIndex].classList.add('previous');
      this.shots[currentIndex].classList.add('previous');
      this.products[currentIndex].classList.remove('active');
      this.shots[currentIndex].classList.remove('active');
      
      // Make next item slide in from right
      this.products[nextIndex].classList.add('active');
      this.shots[nextIndex].classList.add('active');
      
      // Fade update product info - sync with slide animation
      this.updateProductInfo(nextIndex);
      
      // Update current index
      this.currentIndex = nextIndex;
      
      // Reset animation state after transition
      setTimeout(() => {
        // Keep current state for active and previous items
        for (let i = 0; i < this.totalItems; i++) {
          if (i !== nextIndex && i !== currentIndex) {
            this.products[i].classList.remove('active', 'previous', 'next-out');
            this.shots[i].classList.remove('active', 'previous', 'next-out');
            
            // Make sure other items stay with lowest z-index
            this.products[i].style.zIndex = 1;
            this.shots[i].style.zIndex = 1;
          }
        }
        this.isAnimating = false;
        this.updateButtonStates();
      }, 600);
    },
    
    // Go to previous item
    goToPrev: function() {
      if (this.isAnimating || this.totalItems <= 1) return;
      this.isAnimating = true;
      
      // Update button states
      this.updateButtonStates();
      
      // Get current and prev indices
      const currentIndex = this.currentIndex;
      const prevIndex = (currentIndex - 1 + this.totalItems) % this.totalItems;
      
      // Set z-indexes - current needs to stay on top initially
      this.products[currentIndex].style.zIndex = 3; // Current item on top
      this.shots[currentIndex].style.zIndex = 3;
      this.products[prevIndex].style.zIndex = 2; // Prev item middle
      this.shots[prevIndex].style.zIndex = 2;
      
      // Position the prev item off-screen to the left WITHOUT transition
      this.products[prevIndex].style.transition = 'none';
      this.shots[prevIndex].style.transition = 'none';
      this.products[prevIndex].classList.add('previous');
      this.shots[prevIndex].classList.add('previous');
      
      // Force browser to apply the transform before re-enabling transitions
      void this.products[prevIndex].offsetWidth;
      void this.shots[prevIndex].offsetWidth;
      
      // Re-enable transitions
      this.products[prevIndex].style.transition = '';
      this.shots[prevIndex].style.transition = '';
      
      // Make current item slide out to right
      this.products[currentIndex].classList.add('next-out');
      this.shots[currentIndex].classList.add('next-out');
      this.products[currentIndex].classList.remove('active');
      this.shots[currentIndex].classList.remove('active');
      
      // Make prev item slide in from left
      this.products[prevIndex].classList.add('active');
      this.shots[prevIndex].classList.add('active');
      this.products[prevIndex].classList.remove('previous');
      this.shots[prevIndex].classList.remove('previous');
      
      // Fade update product info - sync with slide animation
      this.updateProductInfo(prevIndex);
      
      // Update current index
      this.currentIndex = prevIndex;
      
      // Reset animation state after transition
      setTimeout(() => {
        // Reset other items not involved in transition
        for (let i = 0; i < this.totalItems; i++) {
          if (i !== prevIndex && i !== currentIndex) {
            // Leave the current/next-out item with 'next-out' class
            this.products[i].classList.remove('active', 'previous', 'next-out');
            this.shots[i].classList.remove('active', 'previous', 'next-out');
          }
        }
        this.isAnimating = false;
        this.updateButtonStates();
      }, 600);
    },
    
    // Update product info with fade animation
    updateProductInfo: function(index, animate = true) {
      const title = this.products[index].dataset.productTitle;
      const priceHTML = this.products[index].querySelector('.product-highlights__info').innerHTML;
      
      if (animate) {
        // Fade out and in simultaneously with the slide
        this.productTitle.classList.add('fading');
        this.productPrice.classList.add('fading');
        
        // Update content halfway through the fade
        setTimeout(() => {
          this.productTitle.textContent = title;
          this.productPrice.innerHTML = priceHTML;
          
          // Fade in
          this.productTitle.classList.remove('fading');
          this.productPrice.classList.remove('fading');
        }, 400); // Half of the slide transition time
      } else {
        // Initial setup without animation
        this.productTitle.textContent = title;
        this.productPrice.innerHTML = priceHTML;
      }
    },
    
    // Update next/prev button states (disabled during animation)
    updateButtonStates: function() {
      if (this.isAnimating) {
        this.nextButton.setAttribute('disabled', 'disabled');
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
        this.prevButton.removeAttribute('disabled');
      }
    },
    
    // Auto-slide functionality
    startAutoSlide: function() {
      this.autoSlideInterval = setInterval(() => {
        if (!this.autoSlidePaused && !this.isAnimating) {
          this.goToNext();
        }
      }, 3000);
    },
    
    pauseAutoSlide: function() {
      // this.autoSlidePaused = true;
    },
    
    resumeAutoSlide: function() {
      // this.autoSlidePaused = false;
    },

    // Add this new method:
    resetAutoSlide: function() {
      clearInterval(this.autoSlideInterval);
      this.startAutoSlide();
    },
  };
  
  productHighlights.init();
});